import {Grid, Select, SelectOptionItem, Typography} from '@logistics-frontend/blocks'
import {useI18n} from '@logistics-frontend/core/i18n'
import React from 'react'

import {useQuerySync} from '../../hooks'
import {SelectProps, ZonalPrice} from '../../types'
import TransferPickup from './TransferPickup'
import TransferRide from './TransferRideBlock'

type TransfersProps = {
  transferSelectProps: SelectProps
  transferDetails: ZonalPrice
  currencySign: string
}

const Transfers: React.FC<TransfersProps> = ({transferSelectProps, transferDetails, currencySign}) => {
  const t = useI18n()
  const [transferValue, setTransfer] = useQuerySync('transfer', transferSelectProps.value)

  const handleTransferChange = (option: SelectOptionItem | null) => {
    setTransfer(String(option?.value || ''))
  }

  return transferDetails ? (
    <Grid spacing={2} container>
      <Grid xs={12} item>
        <Typography
          style={{
            paddingBlockStart: 32,
            paddingBlockEnd: 12,
          }}
          variant="body2"
        >
          {t('tariffs.block_title.transfers')}
        </Typography>
        <Select
          onChange={handleTransferChange}
          options={transferSelectProps.options}
          placeholder={t('tariffs.block_title.transfers')}
          value={transferValue}
        />
      </Grid>
      <TransferPickup
        currencySign={currencySign}
        title={t('tariffs.block_title.landing')}
        transferDetails={transferDetails}
      />

      <TransferRide
        currencySign={currencySign}
        title={t('tariffs.block_title.ride')}
        transferDetails={transferDetails}
      />
    </Grid>
  ) : null
}

export default Transfers
